import 'css-chunksrc/client/scenes/projectVirtualResourceAddition/virtualResourceForm/roleSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_qtdyh_1",
  "input": "_input_qtdyh_5",
  "selection": "_selection_qtdyh_18",
  "placeholder": "_placeholder_qtdyh_24",
  "list": "_list_qtdyh_28",
  "role": "_role_qtdyh_1",
  "iconBox": "_iconBox_qtdyh_55",
  "icon": "_icon_qtdyh_55",
  "opened": "_opened_qtdyh_65",
  "selectedRole": "_selectedRole_qtdyh_74",
  "selectedRoleIcon": "_selectedRoleIcon_qtdyh_78",
  "selectedRoleTitle": "_selectedRoleTitle_qtdyh_84",
  "roleDescription": "_roleDescription_qtdyh_91"
};